module.exports = __webpack_public_path__ + "static/media/9.adb1b1d4.jpg";